const organizationTypes = {
	ADMIN: "admin",
	PRODUCER: "producer",
	PUBLISHER: "publisher",
	NARRATOR: "narrator",
};

export default organizationTypes;
